<template>
  <vxe-grid ref="rankAltTable" v-bind="vxeOption"> </vxe-grid>
</template>

<script>
import {
  rankAltTableOptionColums,
  tableOption,
} from "@/views/report/indicators/option/tableOption.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vxeOption: {},
    };
  },
  computed: {
    ...mapGetters(["rankAltTableData"]),
  },
  watch: {
    rankAltTableData: {
      deep: true,
      handler(newVal, oldVal) {
        this.getTableData();
      },
    },
  },
  methods: {
    getTableData() {
      this.$refs.rankAltTable.reloadData(this.rankAltTableData.records);
    },
  },
  created() {
    Object.assign(this.vxeOption, tableOption);
    this.vxeOption.columns = rankAltTableOptionColums;
  },

  mounted() {
    // this.getTableData();
  },
};
</script>

<style lang="scss"></style>
